var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcRefresh = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.536 3.864a4.42 4.42 0 0 1 4.665.8l-.26-.011a.75.75 0 1 0-.071 1.498l2.04.097a.75.75 0 0 0 .786-.73l.054-2.15a.75.75 0 1 0-1.5-.037l-.006.255A5.922 5.922 0 0 0 5.96 2.479 5.97 5.97 0 0 0 3.08 5.01a6.034 6.034 0 0 0 .911 7.228 5.925 5.925 0 0 0 7.176 1.009 6 6 0 0 0 2.547-2.868.75.75 0 1 0-1.38-.586 4.5 4.5 0 0 1-1.91 2.15 4.425 4.425 0 0 1-5.362-.755 4.534 4.534 0 0 1-.683-5.428 4.47 4.47 0 0 1 2.156-1.897",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcRefresh);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };